<template>
  <div
    v-if="isMethodDefault(header.show, null, true)"
    v-bind="config.bind"
    style="display: flex"
  >
    <Form
      ref="formInline"
      :model="searchForm"
      :rules="config.rules"
      :inline="config.inline === undefined ? true : config.inline"
      v-bind="config.formBind"
      @submit.native.prevent
      style="width: calc(100% - 46px)"
    >
      <ContentExpand
        v-if="header.render"
        :render="header.render"
      ></ContentExpand>
      <template v-if="searchs.length">
        <template v-for="(item, idx) in searchs">
          <FormItem
            v-if="
              isMethodDefault(
                item.show,
                { field: item, fields: searchs, searchForm },
                true
              ) &&
                ((isCollapse &&
                  (idx < searchLength ||
                    item.key == 'keywords' ||
                    item.key == 'searchType' ||
                    item.key == 'keywordsType')) ||
                  !isCollapse)
            "
            :key="'Item' + item.key"
            v-bind="item.formItemBind"
            :prop="item.key"
          >


            <Select
              style="width: 150px"
              v-if="item.component === 'Select'"
              v-model="searchForm[item.key]"
              :placeholder="
                handlePlaceholder(item, {
                  searchForm,
                  field: item
                })
              "
              :clearable="item.clearable == undefined ? true : item.clearable"
              :filterable="
                item.filterable == undefined ? true : item.filterable
              "
              label-in-value
              @on-change="
                $page.handleMethod({
                  methods: item.methods,
                  name: 'on-change',
                  searchForm,
                  row: searchForm,
                  field: item,
                  fields: searchs,
                  _value: $event
                })
              "
              v-bind="item.bind"
            >
              <Option
                v-for="child in item.options"
                :label="
                  isMethodDefault(
                    item.config && item.config.label,
                    { searchForm, field: item, row: child },
                    getProp(child, item.config, 'label')
                  )
                "
                :value="getProp(child, item.config, 'value')"
                :key="getProp(child, item.config, 'value')"
              ></Option>
            </Select>

            <AutoComplete
              v-else-if="item.component === 'AutoComplete'"
              v-model="searchForm[item.key]"
              v-bind="item.bind"
              :data="item.data"
              :placeholder="item.placeholder()"
              @on-search="(v) => {
                item.onSearch({value: v, item})
              }"
            ></AutoComplete>

            <RadioGroup
              v-else-if="item.component === 'Radio'"
              v-model="searchForm[item.key]"
              v-bind="item.bind"
              @on-change="
                $page.handleMethod({
                  methods: item.methods,
                  name: 'on-change',
                  searchForm,
                  row: searchForm,
                  field: item,
                  fields: searchs,
                  _value: $event
                })
              "
            >
              <Radio
                v-for="child in item.options"
                :label="getProp(child, item.config, 'value')"
                :border="item.bind ? item.bind.border : false"
                :key="getProp(child, item.config, 'value')"
                >{{ getProp(child, item.config, "label") }}</Radio
              >
            </RadioGroup>
            <component
              v-else-if="item.component"
              :disabled="isMethod(item.disabled)"
              style="width: 150px"
              :placeholder="
                handlePlaceholder(item, {
                  searchForm,
                  field: item
                })
              "
              :is="isMethod(item.component)"
              v-bind="item.bind"
              v-on="item.on"
              v-model="searchForm[item.key]"
              :min="isMethod(item.bind && item.bind.min)"
              :max="isMethod(item.bind && item.bind.max)"
              :options="
                item.component === 'DatePicker'
                  ? Object.assign(
                      item.disabledDate ? {} : pickerOptions,
                      item.bind && item.bind.options ? item.bind.options : {}
                    )
                  : item.bind && item.bind.options
              "
              @on-enter="
                handleMethod({ methods: item.methods, name: 'on-enter' })
              "
              @on-change="
                handleMethod({ methods: item.methods, name: 'on-change' })
              "
              @on-ok="handleMethod({ methods: item.methods, name: 'on-ok' })"
              @on-input="
                handleMethod({ methods: item.methods, name: 'on-input' })
              "
              @on-clear="
                handleMethod({ methods: item.methods, name: 'on-clear' })
              "
              @on-click="
                handleMethod({ methods: item.methods, name: 'on-click' })
              "
            ></component>
          </FormItem>
        </template>

        <FormItem v-if="!config.hideSubmit">
          <Button type="primary" icon="ios-search" @click="handleSubmit()">{{
            config.searchText ? config.searchText : $t("search")
          }}</Button>
        </FormItem>
      </template>
      <template v-for="(btn, idm) in btnList">
        <FormItem
          :key="'Btn' + (btn.type || idm)"
          v-if="
            hasPermission(btn.id) &&
              isMethod(
                btn.show,
                { field: btn, fields: btnList, searchForm },
                true
              )
          "
        >
          <template v-if="btn.component === 'Upload'">
            <Upload
              multiple
              action=""
              with-credentials
              :show-upload-list="
                hasPermission(btn.id) && btn.bind.showUploadList
              "
              :before-upload="
                btns.methods[btn.fnName]
                  ? file => {
                      handleMethod({
                        methods: btns.methods,
                        name: btn.fnName,
                        file,
                        field: btn,
                        fields: btnList,
                        searchForm
                      });
                      return false;
                    }
                  : btn.methods['before-upload']
              "
              v-bind="btn.upBind"
            >
              <!-- <div style="padding: 20px 0"> -->
              <!-- <Icon
                  type="ios-cloud-upload"
                  size="52"
                  style="color: #3399ff"
                  v-if="btn.icon"
                ></Icon> -->
              <Button
                :disabled="$page.isMethod(btn.disabled, { searchForm })"
                :type="btn.bind && btn.bind.type"
                :icon="btn.bind && btn.bind.icon"
              >
                {{ isMethod(btn.name) }}
              </Button>
              <div v-if="btn.fileName">选中文件：{{ btn.fileName }}</div>
              <!-- </div> -->
            </Upload>
          </template>
          <template v-else-if="btn.label">
            <PrintLabel :ids="$page.selectAll" :en="btn.en" v-bind="btn.bind">
              {{ $tz(isMethod(btn.name)) }}
            </PrintLabel>
          </template>
          <Button
            v-else-if="
              hasPermission(btn.id) &&
                isMethodDefault(
                  btn.show,
                  { field: btn, fields: btnList, searchForm },
                  true
                ) &&
                !btn.list
            "
            :disabled="$page.isMethod(btn.disabled, { searchForm })"
            :size="btn.size"
            @click="
              $page.handleMethod({
                methods: btns.methods,
                name: btn.fnName || 'click',
                field: btn,
                fields: searchs,
                searchForm
              })
            "
            v-bind="btn.bind"
            >{{ isMethod(btn.name) }}</Button
          >
          <Dropdown
            v-if="hasPermission(btn.id) && btn.list"
            v-bind="btn.bind"
            transfer
            @on-click="
              handleDropoDown($event, { fields: btn, methods: btns.methods })
            "
          >
            <Button
              :disabled="$page.isMethod(btn.disabled, { searchForm })"
              v-bind="btn.btnBind"
            >
              {{ isMethod(btn.btnName || btn.name) }}
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu
              v-if="!$page.isMethod(btn.disabled, { searchForm })"
              slot="list"
            >
              <template v-for="(childBtn, index) in btn.list">
                <DropdownItem
                  :disabled="$page.isMethod(childBtn.disabled, { searchForm })"
                  :name="index"
                  :key="'DDI' + index + childBtn.type"
                  v-if="hasPermission(childBtn.id)"
                >
                  {{ isMethod(childBtn.name) }}
                </DropdownItem>
              </template>
            </DropdownMenu>
          </Dropdown>
        </FormItem>
      </template>
      <FormItem v-if="filterFields && filterFields.length > searchLength">
        <Button
          type="dashed"
          :icon="isCollapse ? 'ios-arrow-down' : 'ios-arrow-up'"
          @click="collapsebtn"
          >{{ isCollapse ? $t("expand") : $t("collapse") }}</Button
        >
      </FormItem>
    </Form>
    <vxe-toolbar
      v-if="config.custom"
      ref="xToolbar"
      :custom="config.custom"
      style="display: inline-block; width: 34px"
    ></vxe-toolbar>
  </div>
</template>

<script>
import ContentExpand from "./expand";
import format from "@/utils/format.js";
import { optionsApi, optionsCommonApi } from "@/libs/api.request.js";
export default {
  inject: {
    $page: {
      default() {
        return this;
      }
    },
    $modal: {
      default: () => ({})
    }
  },
  components: {
    ContentExpand
  },
  props: {
    pageConfig: {
      type: Object,
      default: () => ({})
    },
    searchs: {
      type: Array,
      default: () => []
    },
    btns: {
      type: Object,
      default: () => ({ list: [] })
    },
    config: {
      type: Object,
      default: () => ({ custom: true })
    },
    header: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    btnList() {
      return this.btns.list;
    },
    filterFields() {
      return this.searchs.filter(field => {
        // if(field.optionsFn)
        let show = this.isMethodDefault(
          field.show,
          {
            row: this.searchForm,
            field,
            value: this.searchForm && this.searchForm[field && field.key],
            searchForm: this.searchForm,
            fields: this.searchs
          },
          true
        );
        if (
          show &&
          field.optionsFn &&
          (!field.options || !field.options.length) &&
          !field.noAuto
        ) {
          optionsApi(field, field.optionsFn);
        }
        return show;
      });
    }
  },
  data() {
    return {
      searchForm: {},
      ruleInline: {},
      pickerOptions: {
        disabledDate(time) {
          return time && time.getTime() > Date.now();
        }
      },
      dateTime: "",
      btnRole: [],
      // isLaunch: false,
      searchLength: 10,
      isCollapse: true,
      format
    };
  },
  watch: {
    config: {
      immediate: true,
      handler(val) {
        if (val.rules)
          Object.keys(val.rules).forEach(name =>
            val.rules[name].forEach(rule => {
              if (rule.validator) rule.validator = rule.validator.bind(this);
            })
          );
        if (val.searchLength) this.searchLength = val.searchLength;
      }
    },
    searchs: {
      immediate: true,
      handler(val, old) {
        val &&
          val.forEach(field => {
            if (
              process.env.NODE_ENV === "development" &&
              (field.key == "client_id" || field.key == "clientId")
            )

            this.$set(
              this.searchForm,
              field.key,
              this.isMethod(field.default) !== undefined
                ? this.isMethod(field.default)
                : this.searchForm[field.key] || ""
            );
          });
      }
    }
  },
  created() {
    /* optionsApi('country').then(res=>{
			console.log('optionsApi',res);
			optionsApi('country').then(res=>{
				console.log('optionsApi',res);
			})
		}) */
    this.$nextTick(() => {
      optionsCommonApi(
        this.searchs.reduce((a, b) => {
          if (b.options && !b.options.length && !b.noAuto)
            b.optionsKey && a.set(b, b.optionsKey);
          return a;
        }, new Map())
      );
    });
    // console.log("search created", this.$route, this.$store.state.user.btnList);
    this.btnRole = this.searchs.forEach(async field => {
      if (field.methods && field.methods.list) {
        this.handleMethod({ methods: field.methods, name: "list", field });
      }
    });
    let timer = setTimeout(() => {
      if (this.config.custom && this.$page.getTable && this.$page.getTable())
        this.$page.getTable().connect(this.$refs.xToolbar);
      clearTimeout(timer);
    }, 0);

    // if (this.config.custom && this.$page.getTable()) {
    //   console.log(this);
    // }
    // this.$page.getTable().connect(this.$refs.xToolbar);
  },
  methods: {
    collapsebtn() {
      this.isCollapse = !this.isCollapse;
    },
    hasPermission(id) {
      return this.$hasPermission(id);
    },
    handleDropoDown(index, { fields, methods }) {
      let btn = fields.list[index];
      this.$page.handleMethod({
        methods,
        name: btn.fnName || "click",
        field: btn,
        searchForm: this.handleFilterData(),
        fields: fields.list
      });
    },
    handleFilterData(data) {
      let newFormData = {};
      this.filterFields.map(item => {
        if (this.searchForm[item.key] === "") return;
        if (item.methods && item.methods.format)
          newFormData[item.key] = this.$page.isMethod(item.methods.format, {
            value: this.searchForm[item.key],
            field: item,
            newFormData,
            searchForm: this.searchForm
          });
        else if (item.component === "DatePicker" && this.searchForm[item.key]) {
          if (item.bind.type === "datetimerange") {
            if (this.searchForm[item.key][0]) {
              newFormData[item.key] =
                this.$page.format.timeFormat(
                  this.searchForm[item.key][0].setHours(0, 0, 0, 0)
                ) +
                "," +
                this.$page.format.timeFormat(
                  this.searchForm[item.key][1].setHours(23, 59, 59, 59)
                );
            } else newFormData[item.key] = "";
          } else {
            if (["endTime", "end_time"].includes(item.key)) {
              if (typeof this.searchForm[item.key] === "object") {
                this.searchForm[item.key].getHours() === 0 &&
                  this.searchForm[item.key].setHours(23, 59, 59, 59);
              } else if (this.searchForm[item.key]) {
                if (this.searchForm[item.key].slice(-8) === "00:00:00") {
                  this.searchForm[item.key] = new Date(
                    new Date(this.searchForm[item.key]).setHours(23, 59, 59, 59)
                  );
                }
              }
            }
            newFormData[item.key] = this.$page.format.customTime(
              this.searchForm[item.key],
              item.format
            );
          }
        } else newFormData[item.key] = this.searchForm[item.key];
      });
      return Object.assign({}, newFormData, data);
    },
    handlePlaceholder(item, params) {
      let name = {};
      let placeholder = this.$page.isMethodDefault(
        item.placeholder,
        params,
        this.$t(name[item.component]) + item.key
      );
      return placeholder.replace(/(Please Choose)/, "");
    },
    getProp(item, config, name) {
      return item[config ? config[name] || name : name];
    },
    isMethodDefault(methods, params, df) {
      if (typeof methods === "function") return methods.call(this, params);
      return df;
    },
    isMethod(methods, params = {}, df) {
      if (typeof methods === "function")
        return methods.call(this, { ...params, searchForm: this.searchForm });
      return df !== undefined ? df : methods;
    },
    handleMethod({ methods, name, row, field, file, fields }) {
      if (methods && methods[name])
        return methods[name].call(this, {
          row,
          field,
          value: row && row[field && field.key],
          searchForm: this.searchForm,
          fields,
          file
        });
    },
    startTimeChange(time) {
      if (time.slice(-8) === "00:00:00") {
        time = time.split(" ")[0] + " 23:59:59";
        this.dateTime = time;
        this.searchFrom.endTime = this.dateTime;
      } else {
        this.dateTime = this.searchFrom.endTime = "";
      }
    },
    handleSubmit() {
      if (["orderStatusList"].indexOf(this.$route.name) > -1) {
        let daystimestamp = 32 * 1000 * 24 * 3600;
        let isExceed =
          new Date(this.searchForm.endTime).getTime() -
            new Date(this.searchForm.startTime).getTime() >
          daystimestamp;
        if (isExceed) return this.$Message.error(this.$t("time_not_31day"));
      }
      this.$refs["formInline"].validate(valid => {
        if (valid) {
          this.pageConfig.page = 1;
          this.$emit("getList");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
